<template>
  <el-dialog
    :title="!!editData.id ? '编辑' : '添加'"
    :visible.sync="dialogVisible"
    width="50%"
    class="addCostApprovedDialog"
    @close="dialogCloseHandle"
  >
    <div class="danger" v-if="configType === 1">
      注意：行业部的负责人请选择本部IMC,区域部门请选择区域IMC
    </div>
    <el-form class="common_form" label-position="left" ref="approvedDialogForm" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24" v-if="configType === 1 || configType === 2">
          <el-form-item label="费用部门" prop="deptCode">
            <el-cascader v-if="!editData.id" ref="approvedDeptCascader" :props="props" v-model="formData.deptCode"
                         :show-all-levels="false"
            />
            <el-select disabled v-model="formData.deptCode" v-else>
              <el-option v-for="item in deptList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="configType === 1">
          <el-form-item label="费用类型" prop="expeTypeCode">
            <el-select v-model="formData.expeTypeCode" :disabled="!!editData.id">
              <el-option v-for="item in expensesTypeList" :key="item.expenseTypeCode" :label="item.expenseTypeName"
                         :value="item.expenseTypeCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="configType === 2">
          <el-form-item label="负责大区" prop="areaDeptCode">
            <el-cascader v-if="!editData.id" ref="approvedAreaCascader" :props="props" v-model="formData.areaDeptCode"
                         :show-all-levels="false"
            />
            <el-select v-else disabled v-model="formData.areaDeptCode">
              <el-option v-for="item in areaList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="configType === 3">
          <el-form-item label="产品线" prop="productLine">
            <el-input :disabled="!!editData.id" v-model="formData.productLine" />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="configType === 1">
          <el-form-item label="审批角色" prop="userRole">
            <el-select
              v-model="formData.userRole"
              placeholder="请选择"
              :disabled="!!editData.id"
            >
              <el-option v-for="item in roleList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="审批人" prop="userId">
            <el-select
              v-model="formData.userId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="saleLoading"
            >
              <el-option v-for="item in saleList" :key="item.userId" :label="item.combination" :value="item.userId" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandlen">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { expensesJurManagementApi, approvalManagementApi } from '../../service';

export default {
  data () {
    return {
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad (node, resolve) {
          const { level } = node;
          let params = '000';
          if (level > 0) {
            params = node.value;
          }
          if (!node.isLeaf) {
            expensesJurManagementApi.getAllDeptList(params).then(res => {
              if (res.status === '200') {
                let nodeList = res.data.map(item => {
                  return {
                    label: item.deptName,
                    value: item.deptCode,
                    leaf: item.type !== '1'
                  };
                });
                resolve(nodeList);
              }
            });
          } else {
            resolve();
          }
        }
      },
      rules: {
        deptCode: [
          { required: true, message: '请选择申请部门', trigger: 'change' }
        ],
        expeTypeCode: [
          { required: true, message: '请选择费用类型', trigger: 'change' }
        ],
        areaDeptCode: [
          { required: true, message: '请选择负责大区', trigger: 'change' }
        ],
        userId: [
          { required: true, message: '请选择审批人', trigger: 'change' }
        ],
        userRole: [
          { required: true, message: '请选择审批角色', trigger: 'change' }
        ],
        productLine: [
          { required: true, message: '请输入产品线', trigger: 'blur' }
        ]
      },
      deptList: [],
      saleLoading: false,
      dialogVisible: false,
      saleList: [],
      formData: {},
      // 费用归属类型
      expeTypeList: [],
      areaList: [],
      roleList: [
        {
          value: 'headquarter_imc',
          label: '本部IMC'
        },
        {
          value: 'area_imc',
          label: '区域IMC'
        },
        {
          value: 'industry_general_manager',
          label: '行业总经理'
        },
        {
          value: 'industry_manager',
          label: '营销总经理'
        },
        {
          value: 'business_unit_general_manager',
          label: '事业部总'
        },
        {
          value: 'presales_supervisor',
          label: '区域副经理'
        },
        {
          value: 'area_marketing',
          label: '区域营销'
        },
        {
          value: 'region_channel_director',
          label: '大区渠道总监'
        },
        {
          value: 'channel_director',
          label: '渠道总监'
        },
        {
          value: 'marketing_center_general_manager',
          label: '市场中心总经理'
        },
        {
          value: 'sbg_general_manager',
          label: 'SBG总经理'
        }
        // {
        //   value: 'sales_supervisor',
        //   label: '销售主管'
        // }
      ]
    };
  },
  props: {
    configType: {
      type: Number,
      default: 1
    },
    approvedDialogVisible: {
      type: Boolean,
      default: false
    },
    expensesTypeList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    approvedDialogVisible (val) {
      this.dialogVisible = val;
      if (val) {
        if (this.editData.id) {
          this.editHandlen();
        }
        this.$nextTick(() => {
          this.$refs.approvedDialogForm.clearValidate();
        });
      } else {
        this.formData = {};
        this.$refs.approvedDialogForm.resetFields();
        this.saleList = [];
      }
    }
  },
  methods: {
    editHandlen () {
      this.formData = this.editData;
      // 审批人处理
      this.saleList = [
        {
          userId: this.formData.userId,
          userName: this.formData.userName,
          combination: `${this.formData.userName} / ${this.formData.userId}`
        }
      ];
      switch (this.configType) {
        case 1:
          // 申请部门处理
          this.deptList = [
            {
              label: this.formData.deptName,
              value: this.formData.deptCode
            }
          ];
          // 费用类型处理
          this.formData.expeTypeCode = this.formData.expenseTypeCode;
          // 审批角色处理
          this.formData.userRole = this.arrayQuery(this.formData.userRole, this.roleList, 'label').value;
          break;
        case 2:
          // 申请部门处理
          this.deptList = [
            {
              label: this.formData.deptName,
              value: this.formData.deptCode
            }
          ];
          // 负责大区处理
          this.areaList = [
            {
              label: this.formData.areaDeptName,
              value: this.formData.areaDeptCode
            }
          ];
          break;
        default:
          this.$set(this.formData, 'productLine', this.formData.deptName);
      }
    },
    remoteMethod (query) {
      if (query !== '') {
        this.saleLoading = true;
        approvalManagementApi.getApprovedList(query).then(res => {
          if (res.status === '200') {
            this.saleList = res.data && res.data.length > 0 ? res.data.map(item => {
              return {
                ...item,
                combination: `${item.userName} / ${item.userId}`
              };
            }) : [];
          }
          this.saleLoading = false;
        });
      } else {
        this.saleList = [];
      }
    },
    submitHandlen () {
      this.$refs['approvedDialogForm'].validate((valid) => {
        if (valid) {
          // 审批人过滤
          let userObj = this.arrayQuery(this.formData.userId, this.saleList, 'userId');
          let data = {
            configType: this.configType,
            userId: userObj.userId,
            userName: userObj.userName,
            userType: '部门'
          };
          let deptObj = this.$refs['approvedDeptCascader'] ? this.$refs['approvedDeptCascader'].getCheckedNodes()[0] : {};
          switch (this.configType) {
            case 1:
              // 费用归属部门
              if (this.editData.id) {
                data.deptCode = this.formData.deptCode;
                data.deptName = this.formData.deptName;
              } else {
                data.deptCode = deptObj.value;
                data.deptName = deptObj.label;
              }
              // 费用类型
              let expeTypeObj = this.arrayQuery(this.formData.expeTypeCode, this.expensesTypeList, 'expenseTypeCode');
              data.expenseTypeCode = expeTypeObj.expenseTypeCode;
              data.expenseTypeName = expeTypeObj.expenseTypeName;
              // 审批角色
              data.userRole = this.formData.userRole;
              break;
            case 2:
              if (this.editData.id) {
                data.areaDeptCode = this.formData.areaDeptCode;
                data.areaDeptName = this.formData.areaDeptName;
                data.deptCode = this.formData.deptCode;
                data.deptName = this.formData.deptName;
                break;
              }
              // 费用归属部门
              data.deptCode = deptObj.value;
              data.deptName = deptObj.label;
              // 负责大区
              let areaObj = this.$refs['approvedAreaCascader'].getCheckedNodes()[0];
              data.areaDeptCode = areaObj.value;
              data.areaDeptName = areaObj.label;
              break;
            default:
              data.deptName = this.formData.productLine;
              data.userType = '产品线';
          }
          if (!this.editData.id) {
            this.$emit('approvedSubmit', data);
          } else {
            data.id = this.formData.id;
            this.$emit('approvedEdit', data);
          }
        }
      });
    },
    arrayQuery (val, list, findKey) {
      return list.find(item => {
        return item[findKey] === val;
      });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    }
  }
};
</script>

<style lang="scss" scoped>
.addCostApprovedDialog {
  .danger{
    color: #F53E48;
    margin-bottom: 10px;
    line-height: 14px;
  }
}
</style>
